import React, { lazy, Suspense } from 'react';
import { Box } from '@mui/material';
import SttCarregando from '../../../componentes/comum/SttCarregando/SttCarregando';

const Parceiros = lazy(() => import('../../../componentes/parceiros'));

const IndexParceiros = () => {
    return (
        <Box sx={{ padding: 1 }}>
            <Suspense fallback={<SttCarregando />}>
                <Parceiros />
            </Suspense>
        </Box>
    );
};

export default IndexParceiros;
